import { t } from 'i18next';
import React, { useReducer } from 'react'
import { getAccessVehiclesService, getExitVehiclesService } from '../../services/vehicles';
import AccessVehiclesContext from './AccessVehiclesContext'
import AccessVehiclesReducer from './AccessVehiclesReducer';
import { logout } from '../../services/login';

const AccessVehiclesState = ({ children }) => {

    const initialState = {
        accessVehicles: [],
        isFetching: true,
        isFetchingShowMore: false,
        canShowMore: false,
        error: false,
        message: '',
        reg_to: 1,
        accessVehiclesSelected: [],
        initialStateVisitVehicle: {
            plate_number: '',
            observations: '',
            description: '',
        }
    };

    const [state, dispatch] = useReducer(AccessVehiclesReducer, initialState);

    const cleanAccessVehiclesState = () => dispatch({ type: 'CLEAN' });

    const getVehiclesOptions = {
        'ACCESS': getAccessVehiclesService,
        'EXIT': getExitVehiclesService
    }

    const setAccessVehiclesSelected = (accessVehiclesSelected) => {
        dispatch({
            type: 'SET_ACCESS_VEHICLES_SELECTED',
            payload: accessVehiclesSelected
        })
    }

    const setVisitVehiclesSelected = (visitVehicle) => {
        dispatch({
            type: 'SET_VISIT_VEHICLE_SELECTED',
            payload: visitVehicle
        })
    }

    const getAccessVehicles = async (filter, type) => {
        try {
            const response = await getVehiclesOptions[type](filter);
            if (response.ok) {
                const payload = {
                    reg_to: response.data.response.reg_to,
                    vehicles: response.data.response.vehicles,
                    canShowMore: response.data.response.vehicles.length === filter.page_length,
                };
                dispatch({
                    type: 'GET_VEHICLES',
                    payload: payload
                })
            } else {
                const errorType = await response.data.json();
                switch (errorType.error_code) {
                    case 'AUTH_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('TOKEN_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('PERMISSIONS_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('ERROR_TRY_AGAIN')
                        })
                        break;
                }
            }
        } catch (e) {
            console.log(e);
            dispatch({
                type: 'ERROR_SERVER',
                payload: t('SERVER_ERROR')
            });
        }
    }

    const searchAccessVehicles = async (filter, type) => {
        try {
            dispatch({ type: 'IS_FETCHING' });
            const response = await getVehiclesOptions[type](filter);
            if (response.ok) {
                const payload = {
                    reg_to: response.data.response.reg_to,
                    vehicles: response.data.response.vehicles,
                    canShowMore: response.data.response.vehicles.length === filter.page_length,
                };
                dispatch({
                    type: 'GET_VEHICLES',
                    payload: payload
                })
            } else {
                const errorType = await response.data.json();
                switch (errorType.error_code) {
                    case 'AUTH_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('TOKEN_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('PERMISSIONS_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('ERROR_TRY_AGAIN')
                        })
                        break;
                }
            }
        } catch (e) {
            console.log(e);
            dispatch({
                type: 'ERROR_SERVER',
                payload: t('SERVER_ERROR')
            });
        }
    }

    const showMoreAccessVehicles = async (filter, type) => {
        try {
            dispatch({ type: 'IS_FETCHING_SHOW_MORE' });
            const response = await getVehiclesOptions[type](filter);
            if (response.ok) {
                const payload = {
                    reg_to: response.data.response.reg_to,
                    vehicles: state.accessVehicles.concat(response.data.response.vehicles),
                    canShowMore: response.data.response.vehicles.length === filter.page_length,
                };
                dispatch({
                    type: 'GET_VEHICLES',
                    payload: payload
                })
            } else {
                const errorType = await response.data.json();
                switch (errorType.error_code) {
                    case 'AUTH_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('TOKEN_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('PERMISSIONS_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('ERROR_TRY_AGAIN')
                        })
                        break;
                }
            }
        } catch (e) {
            console.log(e);
            dispatch({
                type: 'ERROR_SERVER',
                payload: t('SERVER_ERROR')
            });
        }
    }

    return (
        <AccessVehiclesContext.Provider
            value={{
                accessVehiclesState: state,
                getAccessVehicles,
                searchAccessVehicles,
                showMoreAccessVehicles,
                setAccessVehiclesSelected,
                cleanAccessVehiclesState,
                setVisitVehiclesSelected
            }}
        >
            {children}
        </AccessVehiclesContext.Provider>
    )
}

export default AccessVehiclesState